/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseCommandResult } from '../../models/base-command-result';
import { ChangePlanStatusCommand } from '../../models/change-plan-status-command';

export interface ApiPlanChangePlanStatusPatch$Plain$Params {
  
    /**
     * Plan update command Change Status
     */
    body?: ChangePlanStatusCommand
}

export function apiPlanChangePlanStatusPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiPlanChangePlanStatusPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanChangePlanStatusPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseCommandResult>;
    })
  );
}

apiPlanChangePlanStatusPatch$Plain.PATH = '/api/Plan/ChangePlanStatus';
